import { CSSProperties } from 'react';
import { Result, Typography } from 'antd';

const { Paragraph } = Typography;

const styles: Record<string, CSSProperties> = {
    container: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        backgroundColor: '#f0f2f5',
    },
};

interface ErrorPageParams {
    title?: React.ReactNode | string;
    subTitle?: React.ReactNode | string;
}

const ErrorPage = ({
    title = "Something went wrong",
    subTitle = "We're sorry, but an unexpected error has occurred.",
}: ErrorPageParams) => {
    return (
        <div style={styles.container}>
            <Result
                status="error"
                title={title}
                subTitle={typeof subTitle === 'string' ? (<Paragraph style={{ color: '#666' }}>{subTitle}</Paragraph>) : subTitle}
            />
        </div>
    );
};

export default ErrorPage;
